import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { orderDetailsPrescriptions as OrderDetailsPrescriptionsView } from 'ui/views/widgets/orderDetailsPrescriptions';
import { OrderDetailsPrescriptionsService } from 'services/orderDetailsPrescriptions';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';
import searchQuery from 'query-string';
import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OrderDetailsPrescriptions } from 'ui/containers/OrderDetailsPrescriptions';
 *
 * // render
 * <OrderDetailsPrescriptions propName='propValue'/>
 */
class _OrderDetailsPrescriptions extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        this.handleActionClick = this.handleActionClick.bind( this );

        // member prescriptions instance
        this.orderDetailsPrescriptionsService = new OrderDetailsPrescriptionsService();

        // start member detail data fetch
        this.orderDetailsPrescriptionsData();

    }

    async orderDetailsPrescriptionsData() {
        log.debug( 'OrderDetailsPrescriptions.orderDetailsPrescriptionsData()' );

        // cancel ongoing request
        this.orderDetailsPrescriptionsService.cancel();

        try {
            const { status, data }  = await this.orderDetailsPrescriptionsService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    async initiateFetchNotesAction( { url, payload } ) {
        log.debug( 'OrderDetailsPrescriptions.initiateFetchNotesAction()' );

        this.orderDetailsPrescriptionsService.cancel();

        // show page level preloader
        pageLevelPreloader.show();

        // get status and service data
        const { status, data } = await this.orderDetailsPrescriptionsService.initNotes( {
            url: url,
            data: { ...this.props.requestPayload, data: payload }
        } );
        const tabData = { data: data, requestPayload: { ...this.props.requestPayload, data: payload } };

        // show page level preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

            overlay.open( {
                settings: {
                    modalType: OVERLAY_VIEWS.CSR_ORDER_LINE_NOTES,
                    showCloseButton: false,
                    ignoreOutsideClick: true,
                },
                config: {},
                data: {
                    ...tabData,
                    onCancelClick: () => {
                        overlay.close();
                    },
                },
            } );
        }  else {
            errorOverlay.open(); // show error
        }
    }

    initiateMarkResolvedAction( { action, payload } ) {
        log.debug( 'OrderDetailsPrescriptions.initiateMarkResolvedAction()' );

        const memberId = get( this.props, 'requestPayload.context.memberId', null );
        const patientId = get( this.props, 'requestPayload.context.patientId', null );
        const orderId = get( this.props, 'requestPayload.context.orderId', null );

        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.MARK_RESOLVED,
                showCloseButton: false,
                ignoreOutsideClick: true,
            },
            config: {},
            data: {
                ...action,
                widgetConfig: this.state.componentData.structure.markResolved,
                onSumbitClick: async ( value ) => {
                    
                    overlay.close();

                    // cancel ongoing request
                    this.orderDetailsPrescriptionsService.cancel();

                    // show page level preloader
                    pageLevelPreloader.show();

                    // fetch component data
                    const { status } = await this.orderDetailsPrescriptionsService.initiateMarkResolved( {
                        url: action.url,
                        data: {
                            context: {
                                memberId,
                                patientId
                            },
                            data: {
                                orderId,
                                description: value,
                                rxNumber: payload.rxId
                            },
                        },
                    } );

                    // show page level preloader
                    pageLevelPreloader.hide();

                    // check if response status was success
                    if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {

                        this.setState( {
                            isFetching: true,
                            networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                        }, () => {
                            this.orderDetailsPrescriptionsData();

                            // this.props.history.push( {
                            //     pathname: DASHBOARD_SUB_ROUTES.ORDER_DETAIL,
                            //     search: searchQuery.stringify( {
                            //         orderId,
                            //         memberId,
                            //     } )
                            // } );
                        } );
                        
                    } else {
                        errorOverlay.open(); // show error
                    }
                },
                onCancelClick: () => {
                    overlay.close();
                },
            },
        } );
    }

    handleActionClick( { type, value, item } ) {
        ( 'OrderDetailsPrescriptions.handleActionClick()', type, value, item );

        if( 'groupAction' === type && 'notes' === value.name ) {
            this.initiateFetchNotesAction( {
                url: value.url,
                payload: {
                    rxId: item.id
                }
            } );
        }

        if( 'groupAction' === type && 'markResolved' === value.name ) {
            this.initiateMarkResolvedAction( {
                action: value,
                payload: {
                    rxId: item.values.rxNumber
                }
            } );
        }

        const memberId = get( this.props.location, 'state.memberId', undefined );
        const patientId = get( this.props.location, 'state.patientId', undefined );

        if( 'column' === type && 'rxNumber' === value.name  ) {
            this.props.history.push( {
                pathname: DASHBOARD_SUB_ROUTES.PRESCRIPTION_DETAIL,
                search: searchQuery.stringify( {
                    rxId: item.id,
                } ),
                state: { memberId: memberId, patientId: patientId }
            } );
        }

    }

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        log.debug( 'MemberDetailsPrescriptionsEntityWidget.componentWillUnmount()' );

        this.orderDetailsPrescriptionsService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <OrderDetailsPrescriptionsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                onActionClick={ this.handleActionClick }
            />
        );
    }
}

// set display name
_OrderDetailsPrescriptions.displayName = 'OrderDetailsPrescriptions';

// set default props
_OrderDetailsPrescriptions.defaultProps = {};

// prop types
_OrderDetailsPrescriptions.propTypes = {};

export const OrderDetailsPrescriptions = withRouter( _OrderDetailsPrescriptions );
